import { parseAsPageNumber } from '@shared/utils';
import { OrderType } from '@user-management/graphql';
import { UserStatus } from '@user-management/role-user-management';
import { parseAsInteger, parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';

interface RoleUserListParams {
  sort: OrderType;
  field: string;
  page: number;
  pageSize: number;
  role: string;
}

const defaultRoleUserListParams: RoleUserListParams = {
  sort: OrderType.Desc,
  field: 'lastLoginAt',
  page: 0,
  pageSize: 10,
  role: '',
};

export function useRoleUserListSearchParams() {
  const [{ sort, field, page, pageSize, role, search, status }, setQueryParams] = useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(defaultRoleUserListParams.page),
      pageSize: parseAsInteger.withDefault(defaultRoleUserListParams.pageSize),
      field: parseAsString.withDefault(defaultRoleUserListParams.field),
      sort: parseAsStringEnum<OrderType>(Object.values(OrderType)).withDefault(
        defaultRoleUserListParams.sort,
      ),
      status: parseAsStringEnum<UserStatus | ''>(Object.values(UserStatus)).withDefault(''),
      role: parseAsString.withDefault(defaultRoleUserListParams.role),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize });
  };

  const changeSortingField = (field: string, sort: OrderType) => {
    setQueryParams({ field, sort });
  };

  const changeSearch = (value: string) => {
    setQueryParams({ search: value });
  };

  return [
    {
      sort,
      field,
      page,
      pageSize,
      role,
      search,
      status,
    },
    {
      changePageNumber,
      changePageSize,
      changeSortingField,
      changeSearch,
    },
  ] as const;
}
